import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import swal from "sweetalert2";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ApiCallsService {

  apiEndpoint: string = (environment as any).apiUrl;
  showLoader: boolean = true;

  private _loaderSubject = new Subject<Boolean>();
  loaderState: any = this._loaderSubject.asObservable();

  constructor(private _http: HttpClient, private _router: Router) { }

  get(url: any, param?: any) {
    return this._http.get<any>(this.apiEndpoint + url, { params: param });
  }

  post(url: any, value: any) {
    return this._http.post<any>(this.apiEndpoint + url, value, { responseType: 'text' as 'json' });
  }

  put(url: any, param: any) {
    return this._http.put<any>(this.apiEndpoint + url, param);
  }

  putWithoutLoader(url: any, param: any) {
    this.showLoader = false;
    return this._http.put<any>(this.apiEndpoint + url, param);
  }

  postPut(url: any, value: any, isSavedApi: any) {
    if (isSavedApi)
      return this.post(url, value);
    else
      return this.put(url, value);
  }


  putWithoutInterceptor(url: any, param: any, headers: any) {
    return this._http.put<any>(this.apiEndpoint + url, param, { headers: headers });
  }

  postDataWithoutLoader(url: any, value: any) {
    this.showLoader = false;
    return this._http.post<any>(this.apiEndpoint + url, value, { responseType: 'text' as 'json' });
  }

  getDataWithoutLoader(url: any, param: any) {
    this.showLoader = false;
    return this._http.get<any>(this.apiEndpoint + url, { params: param });
  }
  getDataWitLoaderFirstTime(url: any, param: any, loader: boolean) {
    this.showLoader = loader;
    return this._http.get<any>(this.apiEndpoint + url, { params: param });
  }

  delete(url: any, param: any) {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      body: param,
    };
    return this._http.delete<any>(this.apiEndpoint + url, options);
  }

  errorAlert(text: any, status: any, heading: any) {
    swal
      .fire({
        icon: "warning",
        title: (heading || ""),
        text: text,
        confirmButtonColor: "#0860AC",
      })
      .then((result: any) => {
        if (status) {
          localStorage.clear();
          this._router.navigate(["/"]);
        }
      });
  }

  loader(value: any) {
    this._loaderSubject.next(value);
  }
}
